import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LfsaBotonEditarGridComponent } from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { ColDef, GridApi } from 'ag-grid-community';
import { plmService } from '../../services/plm.services';
import { CatalogosPLMService } from '../../services/catalogosPLM.service';
import { QmMatriz } from '../../models/qm-matriz.model';
import { plmModulo } from '../../diccionarios/plm-diccionario';
import { ClaveValorModel } from 'src/app/model/datos-maestros/claveValorModel';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { DatosMaestrosService } from 'src/app/services/datos-maestros.service';
import { TipoMaterial } from 'src/app/model/datos-maestros/tipoMaterialModel';
import { GrupoArticuloModel } from 'src/app/aplicaciones-modulos/portal-compras/model/grupoArticuloModel';

@Component({
  selector: 'app-qm-matriz-mantenimiento',
  templateUrl: './qm-matriz-mantenimiento.component.html',
  styleUrls: ['./qm-matriz-mantenimiento.component.css']
})
export class QmMatrizMantenimientoComponent implements OnInit {

  public DAT_TITULOS    = plmModulo.titulos.global;
  public GLOBAL_TITULOS = plmModulo.titulos.global;
  public DAT_AG_GRID    = plmModulo.agGrid;

  form: FormGroup;
  data: QmMatriz[] = [];
  isNew = false;
  selectedRecord: QmMatriz;
  titleModal: string;
  loading = false;
  usarioActual: any;

  public frameworkComponents: any;
  public columnDefs: ColDef[] = [];
  public gridApi: GridApi;
  public rowSelection: any;
  public gridColumnApi: any;
  public textoBuscar: string;

  catalogoClaseInspeccion: ClaveValorModel[] = [];
  catalogoClaseUtilizacion: ClaveValorModel[] = [];
  listTipoMaterial: TipoMaterial[];
  listGrupoMaterial: GrupoArticuloModel[];

  siNoVacioOptions = [{ label: 'SI', value: 'SI' }, { label: 'NO', value: 'NO' }, { label: 'No Aplica', value: '' }];
  claveQmOptions = [{ label: 'Z9999', value: 'Z9999' }, { label: 'No Aplica', value: '' }];
  tipoCoaOptions = [{ label: 'ZE23', value: 'ZE23' }, { label: 'No Aplica', value: '' }];

  pmCuantitativaOptions = (pm) => [{ label: pm, value: pm }, { label: 'No Aplica', value: '' }];
  pmCualitativaOptions = (pm) => [{ label: pm, value: pm }, { label: 'No Aplica', value: '' }];
  c1001Options = (val) => [{ label: val, value: val }, { label: 'No Aplica', value: '' }];
  c1002Options = (val) => [{ label: val, value: val }, { label: 'No Aplica', value: '' }];
  c2001Options = (val) => [{ label: val, value: val }, { label: 'No Aplica', value: '' }];
  c3001Options = (val) => [{ label: val, value: val }, { label: 'No Aplica', value: '' }];

  constructor(
    private fb: FormBuilder,
    private utilServices: UtilsService,
    private matrizQmService: plmService,
    private catalogosPLMService: CatalogosPLMService,
    private dMaestrosApiService: DatosMaestrosService,

  ) {
    this.form = this.fb.group({
      tipo: [{ value: '', disabled: true }, Validators.required],
      grupo: [{ value: '', disabled: true }, Validators.required],
      claseInspeccion: [{ value: '', disabled: true }, Validators.required],
      descripcionTipoMaterial: [{ value: '', disabled: true }, Validators.required],
      descripcionGrupo: [{ value: '', disabled: true }, Validators.required],
      descripcionMacrocategoria: [{ value: '', disabled: true }, Validators.required],
      gestionQm: [''],
      especificacionRdl: [''],
      instruccionProcesoClaseInsp03: [''],
      operacionesQmClaseInsp03: [''],
      aprovActivo: [''],
      claveQm: [''],
      tipoCoa: [''],
      puntoInspeccion: [''],
      tipoPuntoInspeccion: ['', Validators.maxLength(20)],
      pm0001Cuantitativa: [''],
      pm0002Cualitativa: [''],
      pm0003Cuantitativa: [''],
      pm0004Cualitativa: [''],
      pm0005Cuantitativa: [''],
      pm0006Cualitativa: [''],
      claseUtilizacion: [''],
      c1001A001: [''],
      c1001A002: [''],
      c1001A003: [''],
      c1001A004: [''],
      c1001A005: [''],
      c1001A006: [''],
      c1001A009: [''],
      c1002A001: [''],
      c1002A006: [''],
      c1002A007: [''],
      c1002A008: [''],
      c1002A009: [''],
      c2001A001: [''],
      c2001A010: [''],
      c3001A001: [''],
      c3001A012: [''],
      qm1001: [false],
      qm1002: [false],
      qm2001: [false],
      qm3001: [false],
      usuarioTransaccion: [''],
    });
  }

  ngOnInit(): void {
    this.loadCatalogos();
    this.listar();
    this.cargarGridcomponent();
    this.usarioActual = JSON.parse(localStorage.getItem('datosUsuarioLogin')).login2;    
  }

  cargarGridcomponent() {
    this.frameworkComponents = { buttonRenderer: LfsaBotonEditarGridComponent };
    this.columnDefs = [
      { cellRenderer: 'buttonRenderer', cellRendererParams: { onClick: this.editRecord.bind(this), label: 'Editar' } },
      //{ cellRenderer: 'buttonRenderer', cellRendererParams: { onClick: this.deleteRecord.bind(this), label: 'Eliminar' } },
      { cellRenderer: 'buttonRenderer', cellRendererParams: { onClick: this.deleteRecord.bind(this), label: 'Eliminar' } },
      { field: 'tipo' },
      { field: 'grupo' },
      { field: 'claseInspeccion' },
      { field: 'descripcionTipoMaterial' },
      { field: 'descripcionGrupo' },
      { field: 'descripcionMacrocategoria' },
      { field: 'gestionQm' },
      { field: 'especificacionRdl' },
      /*{ field: 'instruccionProcesoClaseInsp03' },
      { field: 'operacionesQmClaseInsp03' },
      { field: 'aprovActivo' },
      { field: 'claveQm' },
      { field: 'tipoCoa' },
      { field: 'puntoInspeccion' },
      { field: 'tipoPuntoInspeccion' },
      { field: 'pm0001Cuantitativa' },
      { field: 'pm0002Cualitativa' },
      { field: 'pm0003Cuantitativa' },
      { field: 'pm0004Cualitativa' },
      { field: 'pm0005Cuantitativa' },
      { field: 'pm0006Cualitativa' },
      { field: 'claseUtilizacion' },
      { field: 'c1001A001' },
      { field: 'c1001A002' },
      { field: 'c1001A003' },
      { field: 'c1001A004' },
      { field: 'c1001A005' },
      { field: 'c1001A006' },
      { field: 'c1001A009' },
      { field: 'c1002A001' },
      { field: 'c1002A006' },
      { field: 'c1002A007' },
      { field: 'c1002A008' },
      { field: 'c1002A009' },
      { field: 'c2001A001' },
      { field: 'c2001A010' },
      { field: 'c3001A001' },
      { field: 'c3001A012' },
      { field: 'qm1001' },
      { field: 'qm1002' },
      { field: 'qm2001' },
      { field: 'qm3001' }*/
    ];

    this.rowSelection = 'multiple';
  }

  onQuickFilterChanged() {
    this.gridApi?.setQuickFilter(this.textoBuscar);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  listar() {
    this.loading = true;    
    this.matrizQmService.getAllClasesInpeccion().subscribe(response => {
      this.loading = false;
      if(response) this.data = response;
    }, (error) => {
      console.log(error.message);
      this.loading = false;
    });
  }

  loadCatalogos() {
    this.catalogoClaseInspeccion = this.catalogosPLMService.catalogoClaseInspeccion();
    this.catalogoClaseUtilizacion = this.catalogosPLMService.catalogoClaseUtilizacion();
    this.dMaestrosApiService.getAllTipoMaterial().subscribe(res => {
      this.listTipoMaterial = res;
    }, (error) => {
      console.log(error.message);
    });
  }

  openModal() {
    document.getElementById('abrirModal')?.click();
  }

  closeModal() {
    document.getElementById('cerrarModal')?.click();
  }

  acciones(event) {
    if (event === 'regresar') {
      return this.closeModal();
    }
    this.saveRecord();
  }

  openNew() {
    this.isNew = true;
    this.form.reset();
    this.form.enable();
    this.selectedRecord = {} as QmMatriz;
    this.titleModal = plmModulo.titulos.global.tituloAgregar;
    this.openModal();
  }

  editRecord({ rowData }: { rowData: QmMatriz }) {
    this.isNew = false;
    this.selectedRecord = { ...rowData };
    this.form.reset();
    this.form.enable();
    this.form.patchValue(this.mapQmToForm(rowData));
    this.getGrupoProducto(rowData.tipo);

    this.form.get('tipo').disable();
    this.form.get('grupo').disable();
    this.form.get('claseInspeccion').disable();
    this.form.get('descripcionTipoMaterial').disable();
    this.form.get('descripcionGrupo').disable();
    this.form.get('descripcionMacrocategoria').disable();

    //Mantiene descripcion del registro no de datasap
    this.form.get('grupo').setValue(rowData.grupo);
    this.form.get('descripcionTipoMaterial')?.setValue(rowData.descripcionTipoMaterial);
    this.form.get('descripcionGrupo')?.setValue(rowData.descripcionGrupo);
    this.form.get('descripcionMacrocategoria')?.setValue(rowData.descripcionMacrocategoria);
    this.titleModal = plmModulo.titulos.global.tituloActualizar;
    this.openModal();
  }

  deleteRecord({ rowData }: { rowData: QmMatriz }) {
    rowData.usuarioTransaccion = this.usarioActual;
    
    this.utilServices.confirmarSincronoPromesa({
      title: plmModulo.mensajes.eliminar,
      text: plmModulo.titulos.global.tituloEliminar,
      action: 'Eliminar',
      funcion: this.matrizQmService.deleteQmMatriz(rowData),
      loading: true,
      context: this,
    }).then(() => {
      this.data = this.data.filter(val => !(val.tipo === rowData.tipo && val.grupo === rowData.grupo));
    }).catch(() => {});
  }

  saveRecord() {
    if (this.form.invalid) {
      this.utilServices.alertifyToastWar("Formulario no se puede enviar, verifique sus datos");
      return;
    }

    const record: QmMatriz = { ...this.form.getRawValue() };
    record.qm1001 = this.form.value.qm1001 ? 'X' : '';
    record.qm1002 = this.form.value.qm1002 ? 'X' : '';
    record.qm2001 = this.form.value.qm2001 ? 'X' : '';
    record.qm3001 = this.form.value.qm3001 ? 'X' : '';
    record.usuarioTransaccion = this.usarioActual;

    this.loading = true;
    let mensajeP  = this.isNew ? plmModulo.mensajes.guardar : plmModulo.mensajes.actualizar;

    this.utilServices.confirmarSincronoPromesa({
        title   : mensajeP,
        text    : "Registro de Matriz QM",
        action  : this.titleModal,
        funcion : this.isNew ? this.matrizQmService.createQmMatriz(record) : this.matrizQmService.updateQmMatriz(record)
      }).then(() => {
        this.listar();
        this.loading = false;
        this.closeModal();
      });
      this.loading = false;
  }

  private mapQmToForm(record: QmMatriz) {
    return {
      ...record,
      qm1001: record.qm1001 === 'X',
      qm1002: record.qm1002 === 'X',
      qm2001: record.qm2001 === 'X',
      qm3001: record.qm3001 === 'X',
    };
  }

  //metodos del select
  OnChangeTipo(tipo){
    console.log("Tipo actual", tipo.idTipoMaterial);
    this.form.get("grupo").setValue("");
    this.form.get('descripcionTipoMaterial').setValue(tipo.dscaTipoMaterial);
    this.getGrupoProducto(tipo.idTipoMaterial);     
  }

  //metodos del select
  OnChangeGrupo(grupo){
    if(grupo){
      let descripcion:String = grupo.dscaGrupoArticulo.split("-")[1];
      this.form.get('descripcionGrupo').setValue(descripcion.trim());
    }
  }

  getGrupoProducto(tipoMaterial){
    this.listGrupoMaterial = [];    
    this.dMaestrosApiService.getAllMaterialGrupoByTipoMat(tipoMaterial).subscribe(response => {
      this.listGrupoMaterial = response;
    }, (error) => {
      this.utilServices.alertifyToastWar("No hay grupos para el tipo");
      console.log(error.message);
    });
  }


}
